import { render } from "./OrganizationAnalytics.vue?vue&type=template&id=f5fa990c"
import script from "./OrganizationAnalytics.vue?vue&type=script&lang=js"
export * from "./OrganizationAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__